import React from 'react';
import styled, { css } from 'styled-components';
//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const buttonStyles = css`
    width: ${({ width }) => (width ? width : null)};
    height: ${({ height }) => (height ? height : null)};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    padding: ${({ size }) => {
        if (size === 'xs') return '14px 18px';
        if (size === 's') return '13px 20px';
        if (size === 'm') return '16px 24px';
        if (size === 'l') return '19px 32px';
        return 0;
    }};
    font-family: inherit;
    text-decoration: none;
    background: none;
    cursor: pointer;
    z-index: 1;
    font-size: ${({ $fontSize}) => ($fontSize ?? '1rem')};

    &:hover {
        transition: all 0.3s ease-in-out;
        transform: scale(1.05);
    }
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
    color: ${({ color }) => (color ?? '#FFFFFF')};
    background-color: ${({ $backgroundColor }) => ($backgroundColor ?? '#000000')};
    border-radius: 10rem;
    border-left: ${({ $borderLeft }) => ($borderLeft ??  'none')};

    svg {
        path {
            fill: #FFFFFF;
        }
    }

    &:hover {
        background-color:${( {$hoverBackgroundColor}) => ($hoverBackgroundColor ?? '#222222')};
    }

    &:focus,
    &:focus-visible {
        box-shadow: ${( {$focusBoxShadow} ) => ($focusBoxShadow ?? '0 0 0 3px #222222')}; ;
        outline: none;
    }

    &:disabled {
        color: ${({ $disabledColor }) => ($disabledColor ?? '#53565A')};
        background-color: ${({ $disabledBackgroundColor }) => ($disabledBackgroundColor ?? '#D0D0CE')}; 
        cursor: not-allowed;

        svg {
            path {
                fill: #53565A;
            }
        }
    }
`;
//#endregion
export const StyledButton = styled.button`
    ${buttonStyles}
`;

export const Button = (props) => {
    const { children, variant, size, onClick, color, $backgroundColor, ...rest } = props;

    return (
        <StyledButton variant={variant} size={size} onClick={onClick} color={color} $backgroundColor={$backgroundColor} {...rest}>
            {children}
        </StyledButton>
    );
};

export default Button;